/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateUpdateDto } from '../../models/create-update-dto';
import { ProjectResponseDashboardDto } from '../../models/project-response-dashboard-dto';

export interface DashboardProjectsControllerAddOrUpdateUpdateV1$Params {
  projectId: string;
      body: CreateUpdateDto & {

/**
 * Cover image (optional)
 */
'file'?: Blob;
}
}

export function dashboardProjectsControllerAddOrUpdateUpdateV1(http: HttpClient, rootUrl: string, params: DashboardProjectsControllerAddOrUpdateUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectResponseDashboardDto>> {
  const rb = new RequestBuilder(rootUrl, dashboardProjectsControllerAddOrUpdateUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('projectId', params.projectId, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectResponseDashboardDto>;
    })
  );
}

dashboardProjectsControllerAddOrUpdateUpdateV1.PATH = '/v1/dashboard/projects/{projectId}/updates';
